module.exports = __webpack_public_path__ + "11_hige_gray.7d7b5257.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/son/layer3/11_hige_gray.png
// module id = 0e2Z
// module chunks = 0